import React from 'react';
import goldMedal from '../../../../../../assets/scoreboard/goldMedal.png';
import silverMedal from '../../../../../../assets/scoreboard/silverMedal.png';
import medal from '../../../../../../assets/scoreboard/medal.png';
import classes from './RankCell.module.css';

const RankCell = ({ value }) => {

    const rank = Number(value);

    return (
        <div className={classes.rankCell}>
            {rank === 1 ?
                <img src={goldMedal} className={classes.rankMedal} alt="" />
                : rank === 2 ?
                    <img src={silverMedal} className={classes.rankMedal} alt="" />
                    : rank === 3 ?
                        <img src={medal} className={classes.rankMedal} alt="" />
                        : rank === 0 ?
                            <span className={classes.rankNum}>{'--'}</span>
                            :
                            <span className={classes.rankNum}>{rank}</span>
            }
        </div>
    );
};

export default RankCell;
